import { FullscreenLoader } from 'components/lib/FullscreenLoader';
import type { FC } from 'react';
import { ToastContainer } from 'react-toastify';
import Routes from 'routes/Routes';

const App: FC = () => (
  <>
    <FullscreenLoader />
    <ToastContainer position="top-center" newestOnTop hideProgressBar theme="colored" />
    <Routes />
  </>
);

export default App;
